
const defaultState = {
    paymentForm: {
        model: "PaymentModel",
        form: [
            {
                type: "text",
                label: "Card Number",
                name: "cardNumber",
                placeholder: "Enter Card Number",
                default: '',
                required: true,
                md: 12,
                xs: 12,
                maxLength: 50
            },
            {
                type: "monthYearDatepicker",
                label: "Expiry",
                name: "expiry",
                required: true,
                default: '',
                md: 5,
                xs: 12
            },
            {
                type: "password",
                label: "CVC",
                name: "cvc",
                placeholder: "Enter CVC",
                default: '',
                required: true,
                md: 4,
                xs: 12,
                maxLength: 5
            },
            {
                type: "text",
                label: "Cardholder Name",
                name: "cardHolderName",
                placeholder: "Enter Cardholder Name",
                default: '',
                required: true,
                md: 12,
                xs: 12,
                maxLength: 125
            },{
                type: "text",
                label: "Billing Address",
                name: "billingAddress",
                placeholder: "Enter Billing Address",
                default: '',
                required: true,
                md: 12,
                xs: 12,
                maxLength: 125
            },
            {
                type: "text",
                label: "City",
                name: "city",
                placeholder: "Enter City",
                required: true,
                default: '',
                md: 12,
                xs: 12,
                maxLength: 50
            },
            {
                type: "text",
                label: "State/Province",
                name: "stateProvince",
                placeholder: "Enter State/Province",
                required: true,
                default: '',
                md: 12,
                xs: 12,
                maxLength: 50
            },
            {
                type: "select",
                label: "Country",
                name: "country",
                placeholder: "Select Country",
                required: true,
                default: '',
                md: 12,
                xs: 12,
                maxLength: 50
            },
            {
                type: "text",
                label: "Contact Number",
                name: "contactNumber",
                placeholder: "Enter Contact number",
                required: true,
                default: '',
                md: 12,
                xs: 12,
                maxLength: 50
            },
            {
                type: "text",
                label: "Email Address",
                name: "emailAddress",
                placeholder: "Enter Email Address",
                required: true,
                default: '',
                md: 12,
                xs: 12,
                maxLength: 50
            },
            {
                type: "checkbox",
                label: "Charge recurring subscription to this card?",
                name: "isRecurring",
                default: false,
                md: 12,
                xs: 12
            },
        ]
    }
}

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        default: return state;
    }
}